import { action } from 'typesafe-actions';

import * as types from './types';
import { PublicationRequestParams } from '@interfaces/publication-request-params';

export const fetchPublicationsPage = (params: PublicationRequestParams) =>
    action(types.FETCH_PUBLICATIONS_PAGE, params);

export const fetchPublicationsPageSuccess = (data: any) => action(types.FETCH_PUBLICATIONS_PAGE_SUCCESS, data);
export const fetchPublicationsPageError = (error: any) => action(types.FETCH_PUBLICATIONS_PAGE_ERROR, error);

export const fetchPublicationsByResearcherPage = (id: number, page: number = 1) =>
    action(types.FETCH_PUBLICATIONS_BY_RESEARCHER_PAGE, { id, page });
export const fetchPublicationsByResearcherPageSuccess =
    (data: any) => action(types.FETCH_PUBLICATIONS_BY_RESEARCHER_PAGE_SUCCESS, data);
export const fetchPublicationsByResearcherPageError =
    (error: any) => action(types.FETCH_PUBLICATIONS_BY_RESEARCHER_PAGE_ERROR, error);

export const fetchPublication = (id: number) => action(types.FETCH_PUBLICATION, { id });
export const fetchPublicationSuccess = (data: any) => action(types.FETCH_PUBLICATION_SUCCESS, data);
export const fetchPublicationError = (error: any) => action(types.FETCH_PUBLICATION_ERROR, error);

export const fetchPublicationYears = (themeSlug?: string) => action(types.FETCH_PUBLICATION_YEARS, { themeSlug });
export const fetchPublicationYearsSuccess = (data: any) => action(types.FETCH_PUBLICATION_YEARS_SUCCESS, data);
export const fetchPublicationYearsError = (error: any) => action(types.FETCH_PUBLICATION_YEARS_ERROR, error);
